import { OutdoorKiosk } from './OutdoorKiosk';

export const ContinueAtKiosk = (props: { onComplete: () => void; }) => {
    return <OutdoorKiosk onComplete={props.onComplete} />;
};
